// extracted by mini-css-extract-plugin
export default {"Empty":"Empty_Empty__+al7W","EmptyText1":"Empty_EmptyText1__03Rur","EmptyText2":"Empty_EmptyText2__HPBIz"};